/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_SdhInputs */



/**
* | output |
* | --- |
* | "Remove SDH" |
*
* @param {Remove_SdhInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_sdh = /** @type {((inputs?: Remove_SdhInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_SdhInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer SDH")
	if (locale === "de") return /** @type {LocalizedString} */ ("SDH entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi SDH")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить SDH")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar SDH")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("去除SDH")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SDHを削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एसडीएच को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover SDH")
	return /** @type {LocalizedString} */ ("Remove SDH")
});